import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, TemplateRef } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';
import { MbsSize, ModalService, ModalSettings } from 'mbs-ui-kit';
import { EMPTY, from, Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SharedService {
  private readonly i18nPipe = inject(I18NextPipe);
  private readonly modalService = inject(ModalService);

  protected readonly moduleButton = I18_NAMESPACE_APPS_UI.button;

  confirmRestore<T>(content: string | TemplateRef<any>, action: () => Observable<T>, options?: ModalSettings): Observable<T> {
    const settings: ModalSettings = {
      header: {
        title: this.i18nPipe.transform('common.restore', { format: 'capitalize' })
      },
      size: MbsSize.sm,
      footer: {
        okButton: {
          type: 'primary',
          text: this.i18nPipe.transform(this.moduleButton + ':button.restore', { format: 'capitalize' })
        }
      }
    };

    return from(this.modalService.open(Object.assign({}, settings, options), content)).pipe(
      catchError((err: HttpErrorResponse) => (err instanceof HttpErrorResponse ? throwError(() => err) : EMPTY)),
      switchMap((result) => (result ? action() : EMPTY))
    );
  }
}
